import {
  ModuleProps,
  PermissionUpdateProps,
  SubModuleProps,
} from "./PermissionProps";

export const snakeCaseToNormalText = (snakeCaseString: string) => {
  return snakeCaseString
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char: string) => char.toUpperCase());
};

export const NormalTextToSnakeCase = (normalstring: string) => {
  return normalstring.replace(/\s+/g, "_").toLowerCase();
};

export const mergePermissionModule = (masterData: string, data: string) => {
  try {
    const _mastePermission = JSON.parse(masterData);
    const _userPermission = JSON.parse(data);
    const deepCopiedMasterPermission = JSON.parse(masterData);
    let masterPermision = resetAllValues(deepCopiedMasterPermission);
    for (let entity in _userPermission) {
      for (let subEntity in _userPermission[entity]) {
        if (
          masterPermision.hasOwnProperty(entity) &&
          _userPermission[entity] &&
          masterPermision[entity][subEntity]
        ) {
          for (let permission in _userPermission[entity][subEntity]) {
            if (_mastePermission[entity][subEntity][permission])
              masterPermision[entity][subEntity][permission] =
                _userPermission[entity][subEntity][permission];
          }
        }
      }
    }
    return masterPermision;
  } catch (err) {
    console.error("something went wrong ", err);
  }
};

const resetAllValues = (obj: any) => {
  for (let key in obj) {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      resetAllValues(obj[key]);
    } else {
      obj[key] = false;
    }
  }
  return obj;
};

export const getHeader = (permissionSubModule: SubModuleProps) => {
  return Object.keys(permissionSubModule).length
    ? [...Object.keys(permissionSubModule[Object.keys(permissionSubModule)[0]])]
    : [];
};

export const getUpdatePermission = (
  userPermission: ModuleProps,
  role: string
) => {
  const permission: PermissionUpdateProps = {
    name: role,
    permissions_v2: userPermission,
  };
  return permission;
};
